import { render, staticRenderFns } from "./goal_list.vue?vue&type=template&id=ef2a683a&scoped=true&"
import script from "./goal_list.vue?vue&type=script&lang=js&"
export * from "./goal_list.vue?vue&type=script&lang=js&"
import style0 from "./goal_list.vue?vue&type=style&index=0&id=ef2a683a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a683a",
  null
  
)

export default component.exports